import { render, staticRenderFns } from "./memberHistoryTab.vue?vue&type=template&id=53e89dca&"
import script from "./memberHistoryTab.vue?vue&type=script&lang=js&"
export * from "./memberHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports